import { AccessController } from '@adornis/abac/core/AccessController.js';
import { SimpleRolePolicy } from '@adornis/abac/policies/SimpleRolePolicy.js';
import { DefaultLMSPolicy } from '@nsc/simple-lms/init.js';
import { SmartTeamsLMSPolicy } from './lms-policy.js';

export const accessController = new AccessController({
  policies: [SimpleRolePolicy, SmartTeamsLMSPolicy, DefaultLMSPolicy],
});
